"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.styles = void 0;
const styles = ({ defaults, palette, components, transitions, shadows }) => ({
    root: {
        width: '100%',
        zIndex: 1,
    },
    appFrame: {
        height: defaults.content.height,
        width: '100%',
        minWidth: defaults.content.pageMinWidth,
        background: palette.white,
        zIndex: 1,
        overflow: 'hidden',
        position: 'relative',
        display: 'block',
    },
    appBar: Object.assign({}, components.appBar),
    toolBar: Object.assign({}, components.toolBar),
    content: {
        overflow: 'auto',
        fontWeight: 800,
        height: 'calc(100vh - 70px)',
        backgroundColor: palette.white,
        transition: transitions.create('margin', {
            easing: transitions.easing.sharp,
            duration: transitions.duration.leavingScreen,
        }),
        borderBottom: `1px solid ${palette.cloudyGrey}`,
        paddingLeft: defaults.content.paddingLeftMobile,
        paddingRight: defaults.content.paddingRightMobile,
        '@media (min-width: 769px)': {
            paddingLeft: defaults.content.paddingLeft,
            paddingRight: defaults.content.paddingRight,
        },
        display: 'flex',
        flexDirection: 'column',
    },
    listItemTextContent1: {
        textAlign: 'left',
        fontWeight: '400',
        fontSize: 13,
        '&.header': {
            fontWeight: 400,
            paddingRight: 0,
        },
    },
    settingsIcon: {
        color: palette.slateGrey,
    },
    menuHolder: {
        marginTop: -4,
        display: 'inline',
        height: 'inherit',
        width: 46,
    },
    rightSideContent: {
        textAlign: 'right',
        marginLeft: 'auto',
        fontWeight: '400',
        lineHeight: '54px',
        // marginTop: 2,
    },
    leftSideContent: {
        fontWeight: 500,
        marginTop: 2,
        marginBottom: 6,
        fontSize: 20,
        lineHeight: 'normal',
        '&.sub': {
            fontSize: 14,
            fontWeight: 200,
        },
    },
    inlineText: {
        marginLeft: '10px',
        fontWeight: '500',
        fontSize: '20px',
        '&.with-icon': {
            marginRight: 0,
        },
        lineHeight: '24px',
    },
    inlineTextBalance: {
        fontWeight: '200',
        fontSize: '12px',
        lineHeight: '10px',
        display: 'inline',
    },
    viewButtons: {
        marginLeft: 'auto',
        marginRight: 'auto',
    },
    balanceMenu: {
        display: 'inline-block',
        width: '20px',
        marginRight: -7,
        marginLeft: 5,
        height: 19,
    },
    balanceWrapper: {
        lineHeight: 0,
        verticalAlign: 'middle',
        borderBottom: 'none',
        borderBottomWidth: '1px',
        borderBottomColor: palette.silverGrey,
        marginTop: '0px',
        display: 'block',
        alignItems: 'center',
    },
    navIcon: {
        height: 32,
        width: 32,
    },
    editableIcon: {
        marginLeft: 4,
    },
    editableLabelContainer: {
        width: 'unset',
    },
    register: {
        flexShrink: 0,
        height: 'calc(100% - 1px)',
        background: palette.white,
    },
    zeroStateContainer: {
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        minHeight: 250,
        justifyContent: 'center',
        alignItems: 'center',
        fontSize: 18,
        color: palette.slateGrey,
        margin: 'auto',
    },
    zeroStateImg: {
        height: 64,
        width: 64,
    },
    zeroStateTextHeadline: {
        marginBottom: 10,
        fontWeight: 500,
    },
    zeroStateTextBody: {
        textAlign: 'center',
        maxWidth: '80%',
    },
    noState: {
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        width: '100%',
        paddingBottom: '15%',
        justifyContent: 'center',
        alignItems: 'center',
    },
    divider: {
        borderLeft: `1px solid ${palette === null || palette === void 0 ? void 0 : palette.divider}`,
        marginLeft: 4,
        marginRight: 4,
    },
    tooltip: {
        padding: 16,
        color: palette.text.secondary,
        backgroundColor: palette.background.paper,
        boxShadow: shadows[14],
    },
    arrow: {
        color: palette.background.paper,
    },
    headerTitle: {
        display: 'flex',
        alignItems: 'center',
    },
    dateRangeText: {
        paddingLeft: 5,
        paddingRight: 5,
    },
    headerWrapper: {
        marginRight: 15,
    },
});
exports.styles = styles;
